module.exports = __webpack_public_path__ + "media/cards/10-ffcfea9f.png";